import React from 'react'
import styles from './YearInReview.module.css'

export default function TimeColumn() {
  return <div className={styles.timeColumn} />
}
